/* istanbul ignore file */
import { Column } from "@faire/web/slate/Layout";
import { LoadingSpinner } from "@faire/web/slate/LoadingSpinner";
import React, { lazy } from "react";

export const LazyContent = lazy(() =>
  import(
    /* webpackChunkName: "retailer-exclusivity-details-modal-content" */ "@faire/deprecated-retailer-visitor-shared/features/Exclusivity/DetailsModal/__internal__/Content"
  ).then((m) => ({ default: m.Content }))
);

export const LoadingPlaceholder = () => {
  return (
    <Column
      align="center"
      justify="center"
      style={{ height: "600px", maxHeight: "100%" }}
    >
      <LoadingSpinner />
    </Column>
  );
};
